<template>
    <el-row :gutter="30"  class="mw-100 manage-quote" >
        
        <el-col :lg="24" :xs="24">
            
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addParentQuoteRef"
                    :model="currentQuoteData"
                    :rules="currentQuoteDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageQuote('addQuoteRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        
                        <el-col :lg="3" :xs="24">
                            <el-form-item  label="quote order" prop="seq">
                                <el-input v-model="currentQuoteData.seq"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            <el-form-item  label="quote image" prop="imageBase64">
                                <el-image 
                                    style="width: 250px; height: 250px;margin-right:20px" 
                                    :src="isAddQuote ? currentQuoteData.imageURL :  $getImage(currentQuoteData.imageURL) || ''" 
                                    fit="cover"
                                    :zoom-rate="1.2"
                                    :preview-src-list="[isAddQuote ? currentQuoteData.imageURL : $getImage(currentQuoteData.imageURL)]"
                                    :preview-teleported="true"
                                >
                                    <template #error>
                                        <div class="image-slot">
                                            <font-awesome-icon :icon="['fas', 'image']" />
                                        </div>
                                    </template>
                                </el-image>
                                <el-upload
                                    ref="imageBase64"
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="onUploadImage"
                                    
                                    :on-remove="handleRemoveImage"
                                    accept="image/png, image/jpeg,image/gif"
                                    class="font-24 d-flex align-center flex-1"
                                >
                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                </el-upload>
                            </el-form-item>
                            
                        </el-col>
                       
                        
                        
                    </el-row>
                </el-form>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentQuoteData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addQuoteRef"
                            :model="currentQuoteData"
                            :rules="currentQuoteDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                               
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentQuoteData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        
                                        <ckeditor class="w-100" :editor="editor" v-model="currentQuoteData.translates[index].description" :config="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? editorConfigAr :editorConfig "></ckeditor>
                                    </el-form-item>
                                </el-col>
                               
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
    data(){
        return {
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
               
                // The configuration of the editor.
            },
            editorConfigAr: {
                language: {
                    // The UI will be English.
                    ui: 'ar',

                    // But the content will be edited in Arabic.
                    content: 'ar'
                }
            },
            isAddQuote:true,
            currentQuote:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentQuoteData:{},
            currentQuoteDataRules:{
                value:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                translates:this.$setTranslateRules(['title','description']),
            }
        };
    },
    computed:{
        cachedQuote(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.home?.quotes.currentQuote || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedQuote.id) {
            this.isAddQuote = false;
            this.currentQuoteData = JSON.parse(JSON.stringify(this.cachedQuote))
            this.currentQuoteData.translates = this.$filterPublishedTranslates(this.currentQuoteData.translates)
        }else{
            this.$router.push({
                name:'manage-quote',
            })
            this.currentQuoteDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
            this.isAddQuote = true;
            this.currentQuoteData = this.initState()
        }
    },
    
    methods:{
        initState(){
            return {
                
                translates:this.$setTranslateKeys({
                    'title':'',
                    'description':'',
                })
            }
        },
       
        async manageQuote(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addQuoteRef'].length){
                            this.manageQuoteAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async manageQuoteAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddQuote ? 'addQuote':'updateQuote',this.currentQuoteData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getAllQuotes');
                this.$router.push({
                    name:'quotes-list'
                })
            }
        },
        onUploadImage(file){
            if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
                this.$notify({
                    title:'File Size Exceded',
                    message:'the file uplaoded should be less than 5 MB',
                    type:'warning',
                });
                this.$refs['imageBase64'][0].clearFiles()
            }else{  
                const FR = new FileReader();
                let module = this;
                FR.addEventListener("load", function(evt) {
                    module.currentQuoteData.imageBase64 = evt.target.result;
                }); 
                this.currentQuoteData.imageURL =  URL.createObjectURL(file.raw);

                FR.readAsDataURL(file.raw);
            }
        },    
        handleRemoveImage(){
            this.currentQuoteData.imageURL = this.isAddQuote ? '' : this.cachedQuote.imageURL
        }, 
       
    }
}
</script>
<style lang="scss">
    .manage-quote {
        .ck-editor {
            width:100%;
        }
    }
</style>